// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"4fe21479","168":"54f6125d","269":"11e06150","486":"363dc907","495":"a9b5a013","727":"c199e2aa","886":"7d77aee7","925":"bed251d0","959":"835aa2ac"}[chunkId] + ".chunk.js";
};